import request from '@/utils/request'

/**
 * 查询商铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryShop(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShop',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 设置当前商铺
 * @param {Object} data 商铺数据
 * @returns {Promise} 返回Promise对象
 */
export function setCurrentShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.setCurrentShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}